import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PresentationService {
  private presentationModeSubject = new Subject<{
    action: 'show' | 'hide';
    dashboardId?: string;
    singlePageId?: number;
  }>();

  public presentationMode$ = this.presentationModeSubject.asObservable();

  showDashboardPresentation(dashboardId: string): void {
    this.presentationModeSubject.next({ action: 'show', dashboardId });
  }

  showSinglePagePresentation(dashboardId: string, pageId: number): void {
    this.presentationModeSubject.next({
      action: 'show',
      dashboardId,
      singlePageId: pageId,
    });
  }

  hideDashboardPresentation(): void {
    this.presentationModeSubject.next({ action: 'hide' });
  }
}
